// components/PdfDownloadButton.js
import React from 'react';
import { Button } from '@mui/material';
import PdfGenerator  from './PdfGenerator'

export default function PdfDownload({ contentComponent, filename = 'document.pdf', buttonText = 'Download'}) {
  const handleClick = () => {
    PdfGenerator(contentComponent, filename);
  };

  return <Button variant="outlined" size='small' onClick={handleClick}>{buttonText}</Button>;
}
